(() => {

  // megamenu elements' slide-in retriggers when going back to previously opened items 
  const DESKTOP_MIN = 769;

  const init = () => {
    if (window.innerWidth < DESKTOP_MIN) return;

    const navItems = document.querySelectorAll('.site-nav__details');

    navItems.forEach((details) => {
      const dropdown = details.querySelector('.site-nav__dropdown.megamenu');
      if (!dropdown) return;

      const reset = () => {
        const animated = dropdown.querySelectorAll('.appear-animation, image-element');
        animated.forEach(el => el.classList.remove('aos-animate'));
      };

      const retrigger = () => {
        const columns = dropdown.querySelectorAll('.appear-animation');

        columns.forEach((col, index) => {
          setTimeout(() => {
            col.classList.add('aos-animate');

            const img = col.querySelector('image-element');
            if (img) img.classList.add('aos-animate');
          }, 50 * index);
        });
      };

      // When hovering this nav item, animate in
      details.addEventListener('mouseenter', () => {
        reset();
        retrigger();
      });
    });
  };

  // If script loads after DOM is ready, run immediately; otherwise wait.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
